import { createRoutine, bindRoutineToReduxForm } from 'redux-saga-routines';

// Routines
export const assignAssessmentRoutine = createRoutine(
  'assessment/assignItem/ASSIGN_ASSESSMENT',
);
export const assignAssessment = bindRoutineToReduxForm(assignAssessmentRoutine);

// Standard Actions
export const RESET_ASSIGNMENT_STATE = 'RESET_ASSIGNMENT_STATE';
export const ASSIGNMENT_GROUP_CHANGED =
  'assessment/assignItem/ASSIGNMENT_GROUP_CHANGED';
export const ASSIGNABLE_GROUP_MEMBERS_CHANGED =
  'assessment/assignItem/ASSIGNABLE_GROUP_MEMBERS_CHANGED';

export const resetAssignmentState = () => ({
  type: RESET_ASSIGNMENT_STATE,
});
